module.exports = __webpack_public_path__ + "static/media/key-skeleton.a930194a.svg";